module.exports = __webpack_public_path__ + "img/icon-motul_dark.1e2917cb.png";